import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchPermissions } from '../../actions/project_actions';
import { fetchSetup } from '../../actions/setup_actions';
import Footer from '../footer';
import Sidebar from '../sidebar';
import ProgressReport from './ProgressReport';
import ProjectHeader from './ProjectHeader';
import {TabsComponent} from '../global/tabs';

class ProjectDetail extends Component {

    UNSAFE_componentWillMount () {
        this.props.fetchPermissions(this.props.projectId);
        this.props.fetchSetup()
    }

    renderReport (projectId, hash) {
        const reportId = hash.replace('#report-', '');
        return <ProgressReport projectId={projectId} reportId={reportId}/>
    }

    render() {
        const { location, projectId, permissions, divisionName, 
           aeLookAEServProjId } = this.props;

        let { currentTabIndex } = this.props

        const { hash } = location;
        if (hash.indexOf('#report') === 0) {
            return this.renderReport(projectId, hash);
        }

        if (hash.indexOf('#Contractingmenu') === 0) {
            currentTabIndex = 5
        }

        const projectProps = { projectId, permissions, divisionName, 
            currentTabIndex, aeLookAEServProjId };

        return (
      <div className="project-detail">
        <Sidebar backUrl={this.props.backUrl}
                 divisionName = {this.props.divisionName}
                 permissions = {permissions} />

        <ProjectHeader {...projectProps} />
        <TabsComponent {...projectProps} />

        <Footer/>
      </div>
        );
    }

}

ProjectDetail.propTypes = {
    projectId: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired,
    permissions: PropTypes.object.isRequired,
    backUrl: PropTypes.string.isRequired,
    fetchSetup: PropTypes.func.isRequired,
    fetchPermissions: PropTypes.func.isRequired
};

function mapStateToProps (state, ownProps) {
    return {
        projectId: ownProps.match.params.projectId,
        permissions: state.projectsStore.permissions,
        backUrl: state.projectsStore.detailBackUrl,
        divisionName: state.projectsStore.divisionName,
        currentTabIndex: state.additionalProjectsStore.currentTabIndex,
        aeLookAEServProjId: state.additionalProjectsStore.aeLookAEServProjId
    };
}

export default connect(mapStateToProps, {
    fetchPermissions,
    fetchSetup,
})(ProjectDetail);
